'use client';

import { LINK } from '@constants';
import { useReportBoundaryError } from '@smiledragon-corp/signoz-nextjs/react';
import { Box } from '@viewup/ui';

import { NetworkError } from 'viewup-lib/common';
import { ErrorTemplate } from './_components/ErrorTemplate';

// biome-ignore lint/suspicious/noShadowRestrictedNames: <nextjs 컨벤션>
const Error = ({ error }: { error: Error & { digest?: string } }) => {
  useReportBoundaryError(error);

  if (error instanceof NetworkError) {
    return (
      <Box height='100svh' pt={64} style={{ margin: '0 auto', maxWidth: 440 }} width='100%'>
        <ErrorTemplate
          errorHandleButtonText='메인페이지로 돌아가기'
          onClickErrorHandle={() => {
            window.location.href = LINK.HOME;
          }}
          title={'네트워크 오류가 발생했습니다.'}
        />
      </Box>
    );
  }

  return (
    <Box height='100svh' pt={64} style={{ margin: '0 auto', maxWidth: 440 }} width='100%'>
      <ErrorTemplate
        errorHandleButtonText='메인페이지로 돌아가기'
        onClickErrorHandle={() => {
          window.location.href = LINK.HOME;
        }}
        title={'일시적인 오류가 발생했습니다.'}
      />
    </Box>
  );
};

export default Error;
